module.exports = __webpack_public_path__ + "static/media/Noticias4.ae0526a7.svg";